<template>
  <div class="container">
    <el-card v-loading="loading" :body-style="{padding: 0}" class="rs-card">
      <div class="rs-card-header">
        <h4 class="wallet-head">
          Scheduled Move In ( Total: {{ scheduledMoveInUnits.length }} )
        </h4>
      </div>
      <el-table
        :data="scheduledMoveInUnits"
        :header-cell-style="{padding: '0.25rem'}"
        :default-sort = "{prop: 'moveIn', order: 'ascending'}"
        style="width: 100%; padding: 0"
        max-height="190"
        @row-click="routeToCustomer"
        >
        <el-table-column
          prop="unit.name"
          :width="100"
          label="Unit"
        >
        </el-table-column>
        <el-table-column
          prop="customer.company"
          label="Company"
          :formatter="(row, column, cellValue) => cellValue && cellValue.length > 15 ? `${cellValue.slice(0, 12)}...` : cellValue"
        >
        </el-table-column>
        <el-table-column
          label="Move In"
          prop="moveIn"
          :formatter="(row, column, cellValue) => $options.filters.formatDate(cellValue)"
          >
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.moveIn">
              {{ new Date( scope.row.moveIn).toLocaleDateString() }}
            </span>
          </template> -->
        </el-table-column>
        <el-table-column
          prop="unit.status"
          label="Status"
          :width="120"
          :formatter="(row, column, cellValue) => $options.filters.printableStatus(cellValue)"
          >
        </el-table-column>
        <el-table-column
          label="Required Items"
          :width="165"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.unitInvoice && scope.row.unitInvoice.pendingItems && scope.row.unitInvoice.pendingItems.length > 0">
              <el-tooltip
                v-for="item in scope.row.unitInvoice.pendingItems"
                :key="item._id"
                :content="`${item.reason} ${item.value ? $options.filters.currencySign(item.value, $root.state.facilityData) : ''}`"
              >
                <el-tag size="small">{{ item.key === "Payment" ? '$' : item.key }}</el-tag>
              </el-tooltip>
            </div>
            <el-tag type="success" size="small" v-else>Ready</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card v-loading="loading" :body-style="{padding: 0}">
      <div class="rs-card-header">
        <h4 class="wallet-head">
          Scheduled Move Out ( Total: {{ scheduledMoveOutUnits.length }} )
        </h4>
      </div>
      <el-table
        :data="scheduledMoveOutUnits"
        :header-cell-style="{padding: '0.25rem'}"
        :default-sort = "{prop: 'invoice.end', order: 'ascending'}"
        style="width: 100%; padding: 0"
        max-height="190"
        @row-click="routeToCustomer"
      >
        <el-table-column
          prop="unit.name"
          :width="100"
          label="Unit"
        >
        </el-table-column>
        <el-table-column
          prop="customer.company"
          label="Company"
          :formatter="(row, column, cellValue) => cellValue && cellValue.length > 15 ? `${cellValue.slice(0, 12)}...` : cellValue"
        >
        </el-table-column>
        <el-table-column
          prop="unit.computedSize"
          label="Size"
        >
        </el-table-column>
        <el-table-column
          label="Move Out"
          prop="moveOut"
          :formatter="(row, column, cellValue) => $options.filters.formatDate(cellValue)"
        >
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.invoice && scope.row.invoice.end">
              {{ new Date( scope.row.invoice.end).toLocaleDateString() }}
            </span>
          </template> -->
        </el-table-column>
        <el-table-column
          prop="unitStatus"
          label="Status"
          :formatter="(row, column, cellValue) => $options.filters.printableStatus(cellValue)"
          >
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios';
import { UNIT_RENTAL_API_V2, UNIT_RENTAL_API_V2_1 } from '../env';

export default {
  name: 'FacilityUpcomingScheduledUnits',
  props: {
    facility: { type: String, required: true },
  },
  watch: {
    async facility() {
      this.loading = true;
      await this.getFacilityScheduledUnits();
      this.loading = false;
    },
  },
  async mounted() {
    if (!this.facility) {
      return;
    }

    await this.getFacilityScheduledUnits();
    this.loading = false;
  },
  data() {
    return {
      loading: true,
      scheduledMoveOutUnits: [],
      scheduledMoveInUnits: [],
    };
  },
  methods: {
    async getFacilityScheduledUnits() {
      try {
        //   /admin/api/unit-rental/v1/dashboard/facility/:facility/scheduled
        const response = await axios.get(`${UNIT_RENTAL_API_V2_1}/dashboard/facility/${this.facility}/scheduled`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        const data = response.data.result;

        this.scheduledMoveOutUnits = data.scheduledMoveOutUnits;
        this.scheduledMoveInUnits = data.scheduledMoveInUnits;
      } catch (err) {
        this.$message({
          showClose: true,
          offset: 60,
          type: 'error',
          duration: 10000,
          message: err.response.data,
        });
      }
    },
    routeToCustomer(row) {
      if (this.facility) {
        this.$router.push({ name: 'Facility Customer', params: { id: row.customer && row.customer._id ? row.customer._id : row.unit && row.unit.customer ? row.unit.customer : row.customer, facility: this.facility } });
        return;
      }
      this.$router.push({ name: 'Customer', params: { id: row.customer && row.customer._id ? row.customer._id : row.unit.customer } });
    },
  },
};
</script>

<style scoped>
.container {
  display: grid;
  gap: 1rem;
}

@media (min-width: 768px) {
  .container {
    grid: 1fr / 1fr 1fr;
  }
}

.wallet-text {
  color: #efefef;
  font-weight: 300;
}

.wallet-head {
  font-weight: 400;
  margin: 0;
  color: #009aca;
}
.rs-card-header {
  padding: 0.5rem;
  border-bottom: solid 1px #efefef;
}
</style>



// WEBPACK FOOTER //
// src/components/FacilityUpcomingScheduledUnits.vue